import { useEffect, useRef, useState } from "react";
import { FetchImageByImageId } from "../api/ServerApi";

// 🔥 in-memory cache (safe)
const imageCache = new Map();

export function usePanelImages(selectedPanel) {
  const requestIdRef = useRef(0);

  const [state, setState] = useState({
    loading: false,
    urls: {
      partySymbolUrl: null,
      splashImageUrl: null,
      printerImageUrl: null,
      slipImageUrl: null,
    },
  });

  useEffect(() => {
    if (!selectedPanel) return;

    const reqId = ++requestIdRef.current;

    const ids = {
      party: selectedPanel.PartySymbolImageId,
      splash: selectedPanel.SplashImageId,
      printer: selectedPanel.PrinterImageId,
      slip: selectedPanel.SlipImageId,
    };

    setState((s) => ({ ...s, loading: true }));

    const load = async (id) => {
      if (!id) return null;
      if (imageCache.has(id)) return imageCache.get(id);

      const res = await FetchImageByImageId(id);
      const url = res?.[0]?.ImageUrl || null;
      if (url) imageCache.set(id, url);
      return url;
    };

    (async () => {
      try {
        const [party, splash, printer, slip] = await Promise.all([
          load(ids.party),
          load(ids.splash),
          load(ids.printer),
          load(ids.slip),
        ]);

        // ghansham
        // 🔐 Persist slip image URL for WhatsApp webhook
        if (slip) {
          try {
            localStorage.setItem("WHATSAPP_SLIP_IMAGE_URL", slip);
          } catch (e) {
            // fail silently – localStorage might be unavailable
            console.warn("Failed to store WHATSAPP_SLIP_IMAGE_URL", e);
          }
        }

        if (reqId !== requestIdRef.current) return;

        setState({
          loading: false,
          urls: {
            partySymbolUrl: party,
            splashImageUrl: splash,
            printerImageUrl: printer,
            slipImageUrl: slip,
          },
        });
      } catch {
        if (reqId === requestIdRef.current) {
          setState((s) => ({ ...s, loading: false }));
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedPanel?.PanelNumber,
    selectedPanel?.CorporationId,
  ]);


  return state;
}
